/*!
 * Ajaxinate v2.0.0 — Infinite Scroll or Load More
 */
var Ajaxinate = function (t) {
  var loading = false;
  var container = document.querySelector(t.container);
  var paginationEl = document.querySelector(t.pagination);
  var method = t.method || "scroll";
  var nextPageUrl = "";
  var offset = t.offset || 200;

  // Obtener URL de la siguiente página
  var updateNextPageUrl = function () {
    if (paginationEl) {
      var link = paginationEl.querySelector("a.next");
      if (link) {
        nextPageUrl = link.href;
      }
    }
  };

  // Oculta paginación (opcional)
  var hidePagination = function () {
    if (paginationEl) paginationEl.style.display = "none";
  };

  var showPagination = function () {
    if (paginationEl) paginationEl.style.display = "";
  };

  updateNextPageUrl();

  function loadMore() {
    if (loading || !nextPageUrl) return;

    loading = true;
    paginationEl.classList.add("loading");
    document.dispatchEvent(new CustomEvent("ajaxinate:fetch"));

    fetch(nextPageUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var dom = new DOMParser().parseFromString(html, "text/html");

        // ✔ CORRECCIÓN: buscar el nuevo grid correctamente
        var newContainer = dom.querySelector(t.container);

        if (newContainer && newContainer.innerHTML.trim().length > 0) {
          container.insertAdjacentHTML("beforeend", newContainer.innerHTML);
          document.dispatchEvent(new CustomEvent("ajaxinate:load"));
        }

        // Actualizar la paginación
        var newPagination = dom.querySelector(t.pagination);
        if (newPagination) {
          paginationEl.innerHTML = newPagination.innerHTML;
        } else {
          paginationEl.remove();
        }

        updateNextPageUrl();
        loading = false;
      })
      .catch(function () {
        loading = false;
      });
  }

  // Scroll
  if (method === "scroll") {
    window.addEventListener("scroll", function () {
      if (!paginationEl) return;

      var top = paginationEl.getBoundingClientRect().top - window.innerHeight;
      if (top < offset) loadMore();
    });
  }

  // Click (si usas load more)
  if (method === "click" && paginationEl) {
    paginationEl.addEventListener("click", function (e) {
      e.preventDefault();
      loadMore();
    });
  }

  return {
    refresh: function () {
      container = document.querySelector(t.container);
      paginationEl = document.querySelector(t.pagination);
      updateNextPageUrl();
    },
    hidePagination: hidePagination,
    showPagination: showPagination,
  };
};
